export default __webpack_public_path__ + "static/media/welpentreffen_29.1a98b768.jpg";